import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagSV(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-sv" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#icon-flag-sv)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z"
          fill="#005293"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 10V0H14V10H24V14H14V24H10V14H0V10H10Z"
          fill="#FECC02"
        />
        <circle cx="12" cy="12" r="11.5" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
